import { useState, useCallback } from "react";
import { domain, token } from "../../../Security";
import axios from "../../../../api/apiClient";

export const useApprovalPolicy = () => {
  const [loading, setLoading] = useState(false);
  const [policies, setPolicies] = useState([]);
  // const [thresholds, setThresholds] = useState([]);

  // ── Policies (Strategies) ────────────────────────────────────────────────
  const fetchPolicies = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${domain}/api/ApprovalPolicy/policies`);
      setPolicies(res.data);
    } catch (err) {
      console.error("Error fetching policies", err);
    } finally {
      setLoading(false);
    }
  }, []);

  const updatePolicy = async (policyId, strategyType) => {
    try {
      await axios.put(`${domain}/api/ApprovalPolicy/policies/${policyId}`, { strategyType });
      await fetchPolicies();
      return { success: true };
    } catch (err) {
      return { success: false, error: err };
    }
  };

  return {
    loading,
    policies,
    fetchPolicies,
    updatePolicy,
  };
};